import { graphql } from "gatsby"

export const BblMagazineSliderBlockFragment = graphql`
  fragment BblMagazineSliderBlock on WpBlock {
    ... on WpBblMagazineSliderBlock {
      name
      attributes {
        className
      }
    }
  }
`

// This is the string version of this that is used within previews and without WP prefixes
export const BblMagazineSliderBlockPreview = `
    ... on BblMagazineSliderBlock {
        name
        attributes {
            className
        }
    }
`
